"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CreateSubscriptionTypeCommand model module.
 * @module model/CreateSubscriptionTypeCommand
 * @version 1.1.3-alpha.1
 */
class CreateSubscriptionTypeCommand {
  /**
   * Constructs a new <code>CreateSubscriptionTypeCommand</code>.
   * @alias module:model/CreateSubscriptionTypeCommand
   * @param is_trial {Boolean} 
   * @param adscores_accessible {Boolean} 
   * @param title {String} 
   * @param sorting_order {Number} 
   * @param duration {Number} 
   * @param max_file_size {Number} 
   * @param max_total_size {Number} 
   * @param max_uploads {Number} 
   * @param user_limit {Number} 
   * @param zoom_meeting_enabled {Boolean} 
   */
  constructor(is_trial, adscores_accessible, title, sorting_order, duration, max_file_size, max_total_size, max_uploads, user_limit, zoom_meeting_enabled) {
    CreateSubscriptionTypeCommand.initialize(this, is_trial, adscores_accessible, title, sorting_order, duration, max_file_size, max_total_size, max_uploads, user_limit, zoom_meeting_enabled);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, is_trial, adscores_accessible, title, sorting_order, duration, max_file_size, max_total_size, max_uploads, user_limit, zoom_meeting_enabled) {
    obj['is_trial'] = is_trial;
    obj['adscores_accessible'] = adscores_accessible;
    obj['title'] = title;
    obj['sorting_order'] = sorting_order;
    obj['duration'] = duration;
    obj['max_file_size'] = max_file_size;
    obj['max_total_size'] = max_total_size;
    obj['max_uploads'] = max_uploads;
    obj['user_limit'] = user_limit;
    obj['zoom_meeting_enabled'] = zoom_meeting_enabled;
  }

  /**
   * Constructs a <code>CreateSubscriptionTypeCommand</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CreateSubscriptionTypeCommand} obj Optional instance to populate.
   * @return {module:model/CreateSubscriptionTypeCommand} The populated <code>CreateSubscriptionTypeCommand</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CreateSubscriptionTypeCommand();
      if (data.hasOwnProperty('is_trial')) {
        obj['is_trial'] = _ApiClient.default.convertToType(data['is_trial'], 'Boolean');
      }
      if (data.hasOwnProperty('adscores_accessible')) {
        obj['adscores_accessible'] = _ApiClient.default.convertToType(data['adscores_accessible'], 'Boolean');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = _ApiClient.default.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('sorting_order')) {
        obj['sorting_order'] = _ApiClient.default.convertToType(data['sorting_order'], 'Number');
      }
      if (data.hasOwnProperty('duration')) {
        obj['duration'] = _ApiClient.default.convertToType(data['duration'], 'Number');
      }
      if (data.hasOwnProperty('max_file_size')) {
        obj['max_file_size'] = _ApiClient.default.convertToType(data['max_file_size'], 'Number');
      }
      if (data.hasOwnProperty('max_total_size')) {
        obj['max_total_size'] = _ApiClient.default.convertToType(data['max_total_size'], 'Number');
      }
      if (data.hasOwnProperty('max_uploads')) {
        obj['max_uploads'] = _ApiClient.default.convertToType(data['max_uploads'], 'Number');
      }
      if (data.hasOwnProperty('user_limit')) {
        obj['user_limit'] = _ApiClient.default.convertToType(data['user_limit'], 'Number');
      }
      if (data.hasOwnProperty('price_prepaid')) {
        obj['price_prepaid'] = _ApiClient.default.convertToType(data['price_prepaid'], 'Number');
      }
      if (data.hasOwnProperty('price_subscription')) {
        obj['price_subscription'] = _ApiClient.default.convertToType(data['price_subscription'], 'Number');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = _ApiClient.default.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('zoom_meeting_enabled')) {
        obj['zoom_meeting_enabled'] = _ApiClient.default.convertToType(data['zoom_meeting_enabled'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CreateSubscriptionTypeCommand</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateSubscriptionTypeCommand</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of CreateSubscriptionTypeCommand.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
      throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
    }
    // ensure the json data is a string
    if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
      throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
    }
    return true;
  }
}
CreateSubscriptionTypeCommand.RequiredProperties = ["is_trial", "adscores_accessible", "title", "sorting_order", "duration", "max_file_size", "max_total_size", "max_uploads", "user_limit", "zoom_meeting_enabled"];

/**
 * @member {Boolean} is_trial
 */
CreateSubscriptionTypeCommand.prototype['is_trial'] = undefined;

/**
 * @member {Boolean} adscores_accessible
 */
CreateSubscriptionTypeCommand.prototype['adscores_accessible'] = undefined;

/**
 * @member {String} title
 */
CreateSubscriptionTypeCommand.prototype['title'] = undefined;

/**
 * @member {Number} sorting_order
 */
CreateSubscriptionTypeCommand.prototype['sorting_order'] = undefined;

/**
 * @member {Number} duration
 */
CreateSubscriptionTypeCommand.prototype['duration'] = undefined;

/**
 * @member {Number} max_file_size
 */
CreateSubscriptionTypeCommand.prototype['max_file_size'] = undefined;

/**
 * @member {Number} max_total_size
 */
CreateSubscriptionTypeCommand.prototype['max_total_size'] = undefined;

/**
 * @member {Number} max_uploads
 */
CreateSubscriptionTypeCommand.prototype['max_uploads'] = undefined;

/**
 * @member {Number} user_limit
 */
CreateSubscriptionTypeCommand.prototype['user_limit'] = undefined;

/**
 * @member {Number} price_prepaid
 */
CreateSubscriptionTypeCommand.prototype['price_prepaid'] = undefined;

/**
 * @member {Number} price_subscription
 */
CreateSubscriptionTypeCommand.prototype['price_subscription'] = undefined;

/**
 * @member {String} description
 */
CreateSubscriptionTypeCommand.prototype['description'] = undefined;

/**
 * @member {Boolean} zoom_meeting_enabled
 */
CreateSubscriptionTypeCommand.prototype['zoom_meeting_enabled'] = undefined;
var _default = exports.default = CreateSubscriptionTypeCommand;